import { useCallback } from 'react'
import { CheckboxInput as UICheckboxInput } from '@calendly/ui/components/checkbox-input'

const Checkbox = ({ onChange, hasError, checked, onKeyDown, ...props }) => {
  const handleChange = useCallback((event) => {
    if (onChange) onChange(event.currentTarget.checked)
  }, [onChange])

  const handleKeyDown = useCallback((event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      if (onChange) onChange(!checked)
    }
    if (onKeyDown) onKeyDown(event)
  }, [onChange, checked, onKeyDown])

  return (
    <UICheckboxInput
      {...props}
      checked={checked}
      aria-invalid={hasError || undefined}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
    />
  )
}

export default Checkbox
